import { render, staticRenderFns } from "./AddBudgetExpenseModal.vue?vue&type=template&id=b1b5a25c"
import script from "./AddBudgetExpenseModal.vue?vue&type=script&lang=js"
export * from "./AddBudgetExpenseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports